export const BAR_TEXTS = {
  sectionTitle: 'Customize Claim Bar Fields',
  sectionDescription: 'You can configure the display name of the fields and decide which fields to show',
  enableField: 'Show',
  save: 'Save',
  cancel: 'Cancel',
  displayNameLabel: 'Display Name',
  fieldKeyLabel: 'Value',
  lobTokenDisplay: 'Line of Business',
  policyNumberHelperText: 'Line of Business token available as {{ LOB }}',
  displayNameRequired: 'Required',
  claimFlagsToggleLockedTooltip:
    'This field has to stay on the bar. Claims may already carry flags, and this field is the only place to see or remove them.',
  configuredBadge: 'Configured',
} as const;

export const SIDEBAR_TEXTS = {
  sectionTitle: 'Customize Claim Sidebar',
  sectionDescription: 'You can configure the display order of the tabs on the sidebar',
  reorderWhileSaving: 'Still saving your last change — please try again in a moment.',
} as const;

export const MOVE_TEXTS = {
  listChanged: 'This list was changed elsewhere and has been reloaded. Please make your move again.',
} as const;
